import { pageHead } from "@/lib/routeHead";
import { createFileRoute, notFound } from "@tanstack/react-router";
import PublicJobDetailPage from "@/pages/PublicJobDetailPage";
import { publicJobQuery } from '@/lib/publicJobs';
import { PublicJobError } from '@/components/PublicJobError';
import { PortalNotFound } from '@/components/PortalNotFound';
import { getPostingMeta } from '@/lib/postingTypes';

export const Route = createFileRoute("/careers/jobs/$slug/")({
  loader: async ({ context, params }) => {
    const result = await context.queryClient.ensureQueryData(publicJobQuery(params.slug));
    if (!result.job) throw notFound();
    return result;
  },
  head: ({ loaderData, params, match }) => pageHead(
    loaderData?.job ? `${loaderData.job.title} | AKIVA Careers` : 'Position Unavailable | AKIVA Careers',
    loaderData?.job?.position_overview?.slice(0, 158) || 'Explore position requirements and opportunities at AKIVA.',
    `/careers/jobs/${params.slug}`,
    match.status === 'notFound' || (!!loaderData?.job && !getPostingMeta(loaderData.job.posting_type).indexable),
  ),
  errorComponent: PublicJobError,
  notFoundComponent: PortalNotFound,
  component: PublicJobDetailPage,
});
